// extracted by mini-css-extract-plugin
module.exports = {"smallScreen":"767px","mediumScreen":"1023px","largeScreen":"1300px","extraLargeScreen":"1600px","content":"InsertHelpTile_content__2PSva","title":"InsertHelpTile_title__35kt2"};